import { PrivacyComponent } from "./../../pages/privacy/privacy.component";
import { MatDialog } from "@angular/material";
import { LocalstorageService } from "./../../services/localstorage.service";
import { CatalogosService } from "./../../catalogos/catalogos.service";
import { Component, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { versionFirebaseService } from "../../firebase-service/firebase-service";

import { GlobalServiceService } from "../../services/global-service.service";

declare var $: any;

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  versionfirebase;
  public samplePagesCollapsed = true;
  public isLogged: boolean;
  private _unsubscribeAll: Subject<any>;
  public menu: any;
  public userInfo = JSON.parse(localStorage.getItem("userInfo"));
  ultimaCarga;
  subscription: Subscription;
  profile: any = this.app.getUserInfo();

  constructor(
    public app: GlobalServiceService,
    config: NgbDropdownConfig,
    public versionFirebaseService: versionFirebaseService,
    public catalogService: CatalogosService,
    private _localstorage: LocalstorageService,
    public dialog: MatDialog
  ) {
    this._unsubscribeAll = new Subject();
    config.placement = "bottom-right";
    this.menu = [];
    this.isLogged = true;
  }

  ngOnInit() {
    this.loadVersion();

    this.app.menuList

      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        let temp = [];
        value.map(async (element) => {
          if (element.name === "Dashboard") {
            let datas = {
              childrens: null,
              icon: element.icon,
              id: element.id,
              name: element.name,
              route: element.route,
              show: element.show,
            };
            temp.push(datas);
          } else {
            temp.push(element);
          }
        });
        this.menu = temp;
      });
    this.app.userInfoData
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        this.userInfo = value;
      });

    this.subscription = this._localstorage
      .getLoginUser()
      .subscribe((message) => {
        this.loadListFiles();
      });
    this.profile ? this.loadListFiles() : '';

  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    this.subscription.unsubscribe();
  }

  expand(child) {
    if ($("#" + child).hasClass("collapse")) {
      $("#" + child).removeClass("collapse");
      $("#" + child).addClass("expand");
    } else {
      $("#" + child).addClass("collapse");
      $("#" + child).removeClass("expand");
    }
  }

  loadVersion() {
    this.versionFirebaseService.getFirebaseVersion().subscribe((version) => {
      this.versionfirebase = version.version;
    });
  }

  loadListFiles() {
    var ultimaCargaaa = [];
    this.catalogService.allFiles().subscribe((resFiles: any) => {

      resFiles.map(async (element) => {
        if (element.type_file === "ordenes") {
          ultimaCargaaa.push(element);
        }
      });
      this.ultimaCarga = ultimaCargaaa[ultimaCargaaa.length - 1];
    });
  }

  goToLink() {
    this.dialog.open(PrivacyComponent, {
      data: {
        animal: "panda",
      },
    });
  }
}
